import moment from "moment";

const ASSET_HOST = "https://selforder.ireachfnb.com";

export const toDisplayText = (value) => {
    if (value == null || value === "undefined" || value === "null") return "";
    if (Array.isArray(value)) return value.map(toDisplayText).filter(Boolean).join(", ");
    if (typeof value === "object") return Object.values(value).map(toDisplayText).filter(Boolean).join(", ");
    return String(value).trim();
};

export const getAssetUrl = (path) => {
    const cleanPath = toDisplayText(path);
    if (!cleanPath) return "";
    if (/^(https?:)?\/\//i.test(cleanPath) || cleanPath.startsWith("data:")) return cleanPath;
    return `${ASSET_HOST}${cleanPath.charAt(0) === "/" ? "" : "/"}${cleanPath}`;
};

export const getCompanyAddress = (company = {}) => {
    return toDisplayText(
        [
            company.address1,
            company.address2,
            company.city,
            company.state,
            company.postal ? `${company.postal}` : ""
        ].filter(Boolean).join(", ")
    );
};

export const getCompanyPhone = (company = {}) => {
    return toDisplayText(
        company.phoneNo ||
        company.phone ||
        company.phoneNumber ||
        company.companyPhone ||
        company.contactNo ||
        company.contactNumber ||
        company.telephone ||
        company.telNo
    );
};

const isEmptyOperatingTime = (timeValue) => {
    const displayText = toDisplayText(timeValue);
    return !displayText || displayText === "0";
};

const formatOperatingTime = (timeValue) => {
    const displayText = toDisplayText(timeValue);
    if (isEmptyOperatingTime(timeValue)) return "";

    const timeInMs = Number(displayText);
    if (!Number.isFinite(timeInMs)) return displayText;

    const parsed = moment(timeInMs);
    if (!parsed.isValid()) return displayText;

    return parsed.format("HH:mm");
};

export const getOperatingHours = (openingTime, closingTime) => {
    if (isEmptyOperatingTime(openingTime) || isEmptyOperatingTime(closingTime)) return "";
    return [formatOperatingTime(openingTime), formatOperatingTime(closingTime)].filter(Boolean).join(" - ");
};

export const getInstagramInfo = (otherUrls) => {
    let urls = otherUrls;

    if (typeof urls === "string") {
        try {
            urls = JSON.parse(urls);
        } catch (error) {
            urls = [];
        }
    }

    if (!Array.isArray(urls)) return null;

    const instagram = urls.find((item) => {
        const title = toDisplayText(item && item.title).toLowerCase();
        const url = toDisplayText(item && (item.url || item.link)).toLowerCase();
        return title.includes("instagram") || title === "ig" || url.includes("instagram.com");
    });

    if (!instagram) return null;

    const rawUrl = toDisplayText(instagram.url || instagram.link);
    const url = rawUrl && /^https?:\/\//i.test(rawUrl) ? rawUrl : rawUrl ? `https://${rawUrl}` : "";
    const pathHandle = url.replace(/\/$/, "").split("/").filter(Boolean).pop();
    const handle = toDisplayText(instagram.handle || instagram.username) || (pathHandle && !pathHandle.includes(".") ? `@${pathHandle}` : toDisplayText(instagram.title));

    return {
        url,
        handle
    };
};
